import Navbar from "./components/Navbar";
import Homescreen from "./pages/Homescreen";
import CategoryDetails from "./pages/CategoryDetails";
import EventDetails from "./pages/EventDetails";
import AboutUs from "./pages/AboutUs";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Homescreen />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/terms" element={<AboutUs />} />
          <Route path="/:categoryName" element={<CategoryDetails />} />
          <Route path="/:categoryName/:id/:name" element={<EventDetails />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
